$(function () {
  (initialize = function() {
    initializeDatePickers();
    initializeSelect2();
    //initializeDataTables();
    initializePoppers();
    initializeInputmasks();
    initializeConfirms();
  })();

  $(document).on('turbolinks:load', function() {
    initialize();
  });

  $('#hamburger').on('click', function() {
    setTimeout(function () {
      store('collapsed', $('body').hasClass('sidebar-collapse'))
    }, 500);
  });

  $(".font-more").click(function () {
    var size = $("body").css('font-size');
    size = size.replace('px', '');
    size = parseInt(size) + 1.4;
    $("body").animate({
      'font-size': size + 'px'
    });
    store('font-size', size);
  });

  $(".font-min").click(function () {
    var size = $("body").css('font-size');
    size = size.replace('px', '');
    size = parseInt(size) - 1.4;
    $("body").animate({
      'font-size': size + 'px'
    });
    store('font-size', size);
  });

  $(".font-reset").click(function () {
    $("body").animate({
      'font-size': '1em'
    });
    remove('font-size');
  });

  if (!$('#unit_id').val() && $('#unit_id option').length > 1) {
    $('#modal-unit').modal('show');
  }

  $.fn.setMinDate = function (minDate) {
    return this.each(function() {
      const input = $(this);
      const dropdowns = input[0].hasAttribute('data-show-dropdowns');
      const maxDate = input.attr('data-max-date');

      input.daterangepicker({
        ...datePickerOptions(minDate, maxDate, dropdowns)
      });

      input.off('change');
      input.change(function() {
        const date = moment(input.val(), "DD/MM/YYYY");
  
        if (
          !date.isValid() ||
          (typeof minDate == 'string' && moment(minDate, "DD/MM/YYYY") > date) ||
          (typeof maxDate == 'string' && moment(maxDate, "DD/MM/YYYY") < date)
        ) { input.val("") }
      });

      input.on('apply.daterangepicker', function(ev, picker) {
        input.val(picker.startDate.format('DD/MM/YYYY'));
        input.change();
      });
    
      input.on('cancel.daterangepicker', function(ev, picker) {
        input.val('');
      });
    });
  };

  $.fn.setMaxDate = function (maxDate) {
    return this.each(function() {
      const input = $(this);
      const dropdowns = input[0].hasAttribute('data-show-dropdowns');
      const minDate = input.attr('data-min-date');

      input.daterangepicker({
        ...datePickerOptions(minDate, maxDate, dropdowns)
      });

      input.off('change');
      input.change(function() {
        const date = moment(input.val(), "DD/MM/YYYY");
  
        if (
          !date.isValid() ||
          (typeof minDate == 'string' && moment(minDate, "DD/MM/YYYY") > date) ||
          (typeof maxDate == 'string' && moment(maxDate, "DD/MM/YYYY") < date)
        ) { input.val("") }
      });

      input.on('apply.daterangepicker', function(ev, picker) {
        input.val(picker.startDate.format('DD/MM/YYYY'));
        input.change();
      });
    
      input.on('cancel.daterangepicker', function(ev, picker) {
        input.val('');
      });
    });
  };
});

window.get = function (name) {
  if (typeof (Storage) !== 'undefined') {
    return localStorage.getItem(name);
  } else {
    window.alert('Por favor, use um navegador moderno para utilizar corretamente este sistema!');
  }
}

window.store = function (name, val) {
  if (typeof (Storage) !== 'undefined') {
    localStorage.setItem(name, val);
  } else {
    window.alert('Por favor, use um navegador moderno para utilizar corretamente este sistema!');
  }
}

window.remove = function (name) {
  if (typeof (Storage) !== 'undefined') {
    localStorage.removeItem(name);
  } else {
    window.alert('Por favor, use um navegador moderno para utilizar corretamente este sistema!');
  }
}

window.initializeDatePickers = function () {
  $('input.datepicker').each(function() {
    const input = $(this);
    const dropdowns = input[0].hasAttribute('data-show-dropdowns');
    const minDate = input.attr('data-min-date');
    const maxDate = input.attr('data-max-date');
    
    input.daterangepicker({
      ...datePickerOptions(minDate, maxDate, dropdowns)
    });

    if (!input.parent().hasClass('input-group')) {
      input.wrap('<div class="input-group"></div>').parent().append(`
        <div class="input-group-append">
          <button class="input-group-text bg-white" type="button" onclick="$(this).closest('.input-group').find('input').focus().trigger('click')">
            <em class="fas fa-calendar"></em>
          </button>
        </div>
      `);
    }

    input.off('change');
    input.change(function() {
      const date = moment(input.val(), "DD/MM/YYYY");

      if (
        !date.isValid() ||
        (typeof minDate == 'string' && moment(minDate, "DD/MM/YYYY") > date) ||
        (typeof maxDate == 'string' && moment(maxDate, "DD/MM/YYYY") < date)
      ) { input.val("") }
    });
  });

  $('input.datepicker').on('apply.daterangepicker', function(ev, picker) {
    const input = $(this);
    input.val(picker.startDate.format('DD/MM/YYYY'));
    input.change();
  });

  $('input.datepicker').on('cancel.daterangepicker', function(ev, picker) {
    $(this).val('');
  });

  Inputmask("99/99/9999").mask('input.datepicker');
}

window.initializeSelect2 = function () {
  $('select.select2').each(function () {
    const select = $(this);
    if (select.next().hasClass('select2-container')) select.next().remove();

    const url = select.data('url');
    const ajaxOptions = (typeof url == 'string' ? {
      ajax: {
        url: url,
        dataType: 'json',
        data: function (params) {
          var query = {
            search: params.term,
            page: params.page || 1
          }
          // Query parameters will be ?search=[term]&page=[page]
          return query;
        }
      }
    } : {});

    if (select[0].hasAttribute('multiple')) {
      const placeholder = select.find('option[value=""]').remove().text();
      const tags = select[0].hasAttribute('data-tags');

      select.select2({
        language: "pt-BR",
        placeholder: placeholder,
        tags: tags,
        width: '100%',
        ...ajaxOptions
      });
    } else {
      select.select2({
        language: "pt-BR",
        width: '100%',
        ...ajaxOptions
      });
    }
  })
}

window.initializeDataTables = function () {
  // Fix sorting of date columns
  $.fn.dataTable.moment('DD/MM/YYYY [às] HH:mm:ss');

  $('table.datatable').each(function () {
    const table = $(this);

    if (table.closest('.dataTables_wrapper').length) {
      return Turbolinks.visit(location.toString());
    }

    table.DataTable({
      initComplete: function() {
        // Adding grouping button
        table.DataTable().button().add(5, getGroupButton(table));
      },
      ...datatableOptions
    });

    // Removing groups befor sorting
    table.find('th').click(function () {
      $('table.datatable').DataTable().rowGroup().disable().draw();
    });
  });
}

window.initializePoppers = function () {
  $('[data-toggle="tooltip"]').tooltip();
}

window.initializeInputmasks = function () {
  $('input[data-input-mask]').each(function () {
    $(this).inputmask($(this).data('input-mask').toString());
  });

  $('input.letters-only').on('input', function () {
		if (this.value.match(/[^A-zÀ-ú ]/g)) {
			this.value = this.value.replace(/[^A-zÀ-ú ]/g, '');
		}
  });
  
  $('input.letters-and-numbers-only').on('input', function () {
		if (this.value.match(/[^A-zÀ-ú0-9 ]/g)) {
			this.value = this.value.replace(/[^A-zÀ-ú0-9 ]/g, '');
		}
  });
}

window.initializeConfirms = function () {
  $('a[data-confirm-generic], button[data-confirm-generic]').click(function() {
    $('#modal-generic-msg').html($(this).attr('data-confirm-generic'));
    $('#modal-generic-link').attr('href', $(this).attr('href'));
    $('#modal-generic').modal('show');

    if ($(this).data('method') !== undefined) {
      $('#modal-generic-link').attr('data-method', $(this).attr('data-method'));
    } else {
      $('#modal-generic-link').removeAttr('data-method');
    }
    
    return false;
  });
}

window.confirmar = function (msg, callback) {
  $('#modal-generic').modal('show');
  $('#modal-generic-msg').html(msg);
  $('#modal-generic-link').off('click').attr('href', 'javascript:;').one('click', function () {
    $('#modal-generic').modal('hide');
    callback();
  });
}

window.alertar = function (msg) {
  $('#modal-generic-alert').modal('show');
  $('#modal-generic-alert-msg').html(msg);
  return false;
}

window.addPerPageParam = function () {
  var baseUrl = [location.protocol, '//', location.host, location.pathname].join(''),
    urlQueryString = document.location.search,
    newParam = 'per_page=' + $('#rows-per-page').val(),
    params = '?' + newParam;

  if (urlQueryString) {
    keyRegex = new RegExp('([\?&])per_page[^&]*');

    if (urlQueryString.match(keyRegex) !== null) {
      params = urlQueryString.replace(keyRegex, "$1" + newParam);
    } else {
      params = urlQueryString + '&' + newParam;
    }
  }
  window.location.href = baseUrl + params;
}

Check = {
  all: function (obj, chk_class) {
    $(chk_class).prop('checked', $(obj).is(':checked'))
  },
  validate: function () {
    if (!$('.chk-all:checked').length) {
      toastr["warning"]("É necessário selecionar ao menos um registro para excluir.");
      return false;
    }

    confirmar("Deseja realmente excluir o(s) registro(s) selecionado(s)?", function () {
      $('#form-grid').submit();
    });

    return false;
  }
};

window.gerarPDFMateriasPesquisadas = function (){
  window.html2pdf = html2pdf;
  var element = document.getElementById('content');
  var opt = {
    margin:       [0.2, 0],
    filename:     "Matérias Pesquisadas - " + new Date().toLocaleDateString(),
    image:        { type: 'jpeg', quality: 0.5 },
    html2canvas:  { scale: 2 },
    jsPDF:        { unit: 'in', format: 'letter', orientation: 'portrait' },
    pagebreak:    { mode: ['avoid-all', 'css', 'legacy'] }
  };
  
  html2pdf().set(opt).from(element).save();
};
